import { useCallback } from 'react';
import { getActiveSubscription } from '@models/Me';
import { getMeLatestUserSubscriptions } from '@api/selectors/subscription';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import SegmentEventsUtil from '@utils/SegmentEventsUtils';
import { emptyObject } from '@constants/empty';
import segmentStorage from '@events/segmentStorage';
import usePlayerStore from './usePlayerStore';
import { getLessonProgrammeType, subscriptionTypes } from '../utils';

const useSegmentAnalytics = () => {
  const latestUserSubscriptions = useMyInfo(getMeLatestUserSubscriptions);

  const { currentClassData } = usePlayerStore();

  const goalUID = currentClassData.programme?.goal?.uid;

  const { subscription = {}, timeRemaining = 0 } =
    getActiveSubscription(latestUserSubscriptions, goalUID) || emptyObject;
  const { type, duration = 'NA' } = subscription;

  const handler = useCallback(
    (data) => {
      SegmentEventsUtil.sendEvent(data, {
        is_enrolled: currentClassData.programme?.isEnrolled || false,
        is_special: currentClassData.programme?.isSpecial || false,
        is_saved: currentClassData.isSaved || false,
        programme_type: getLessonProgrammeType(currentClassData.programmeType),
        goal_uid: goalUID || 'NA',
        goal_name: currentClassData.programme?.goal?.name || 'NA',
        subscription_type: subscriptionTypes[type] || 'NA',
        subscription_duration: duration,
        is_subscription_active: timeRemaining > 0,
        last_primary_source_section: segmentStorage.getItem('lpss', 'NA')
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentClassData.uid, latestUserSubscriptions]
  );

  return handler;
};

export default useSegmentAnalytics;
